import React from 'react';
import { PropTypes } from 'prop-types';
import isNullOrWhiteSpace from 'common/App/isNullOrWhiteSpace';

const CustomerAddressCard = ({ address, jurisdictions, className, showActions, onMakePrimary }) => {
  const getJurisdictionName = (country) => {
    if (country && jurisdictions && jurisdictions.length > 0) {
      const matches = jurisdictions.filter(x => x.code === country || x.name === country);
      if (matches && matches.length > 0) {
        return `${ matches[0].name } (${ matches[0].code })`;
      }
    }
    return country != null && country !== '' ? country : 'N/A';
  };

  const onMakePrimaryClick = () => {
    if (onMakePrimary) {
      onMakePrimary(address);
    }
  };

  return (<div className={ `customer-address-card ${ className }` }>
    { (address.address.line1 || address.address.line2 || address.address.postalCode || address.address.country)
    && <div className="columns" key={ address.id }>
      <div className="col-9 address">
        { !isNullOrWhiteSpace(address.address.line1) && <span>{ address.address.line1 }</span> }
        { !isNullOrWhiteSpace(address.address.line2) && <span>{ address.address.line2 }</span> }
        { !isNullOrWhiteSpace(address.address.line3) && <span>{ address.address.line3 }</span> }
        { !isNullOrWhiteSpace(address.address.line4) && <span>{ address.address.line4 }</span> }
        { !isNullOrWhiteSpace(address.address.postalCode) && <span>{ address.address.postalCode }</span>}
        { address.address.country !== null && <span>{ getJurisdictionName(address.address.countryIso ?? address.address.country) }</span>}
      </div>
      <div className="col-3 pills">
        {address.isPrimary && <div className="chip chip--active mb" title="This address is used as the primary permanent address">PRIMARY</div>}
        { showActions && !address.isPrimary && <button type="button" className="btn btn-link" onClick={ () => onMakePrimaryClick() }>
          <span className="chip chip--active chip--primary--inactive mb" title="Click here to make this Mailing Address the Primary (used for the Prepopulation of Form Data and Data Exports)">MAKE PRIMARY</span>
        </button> }
        { /* eslint-disable-next-line no-bitwise */ }
        {((address.regime & 1) === 1) && <div className="chip chip--address chip--fatca" title="This address is used for FATCA">FATCA</div>}
        { /* eslint-disable-next-line no-bitwise */ }
        {((address.regime & 2) === 2) && <div className="chip chip--address chip--crs" title="This address is used for CRS">CRS</div>}
      </div>
    </div>}
  </div>);
};

CustomerAddressCard.propTypes = {
  address: PropTypes.shape().isRequired,
  jurisdictions: PropTypes.arrayOf(PropTypes.shape),
  className: PropTypes.string,
  showActions: PropTypes.bool,
  onMakePrimary: PropTypes.func
};

CustomerAddressCard.defaultProps = {
  jurisdictions: null,
  className: null,
  showActions: false,
  onMakePrimary: null
};

export default CustomerAddressCard;
